import { render } from 'react-dom'
import { TextureLoader, MathUtils as ThreeMath, UniformsUtils } from 'three'
import { useSpring, useTransition, animated, config } from '@react-spring/three'
import React, { useState, useMemo, useCallback, useRef } from 'react'
import { useDrag } from '@use-gesture/react'
import { Canvas, useThree } from '@react-three/fiber'
import { useTexture, OrbitControls } from '@react-three/drei'
import lanbao from '../../img/lanbao.png'
import lanbao2 from '../../img/lanbao2.png'
// import './styles.css'
const image2 = lanbao2
const image = lanbao
const { degToRad } = ThreeMath
const loader = new TextureLoader()

function Texture({ texture, hoverValue, opacity, onHover, ...props }) {
    return (
        <animated.mesh onPointerMove={e => onHover(true)} onPointerOver={e => onHover(true)} onPointerOut={e => onHover(false)} {...props}>
            <planeBufferGeometry attach="geometry" args={[5, 7]} />
            {/* <animated.shaderMaterial
        attach="material"
        transparent
        args={[{ ...HoverImageShader, uniforms: UniformsUtils.clone(HoverImageShader.uniforms) }]}
        uniforms-texture-value={texture}
        uniforms-hover-value={hoverValue}
        uniforms-opacity-value={opacity}
      /> */}
            <meshBasicMaterial  attach='material' map={texture} transparent opacity={1} />
        </animated.mesh>
    )
}

function Image({ url, backUrl, rotation, ...props }) {
    const [hovered, setHover] = useState(false)

    const { invalidate } = useThree()
    const textures = useTexture([lanbao, image2])
    //   const textures = useMemo(() => {
    //     return [{ id: 'front', texture: loader.load(url, invalidate), deg: 0 }, { id: 'back', texture: loader.load(backUrl, invalidate), deg: 180 }]
    //   }, [url, backUrl, invalidate])

    const { hoverValue } = useSpring({
        hoverValue: hovered ? 1 : 0,
        config: config.molasses
    })

    //   const transitions = useTransition(textures, item =>
    //      item?.id, {
    //     from: { opacity: 0 },
    //     enter: { opacity: 1 },
    //     leave: { opacity: 0 },
    //     config: config.default
    //   })

    return (
        <>
            <Texture
                //   key={key}
                {...props}
                texture={textures[0]}
                hoverValue={hoverValue}
                onHover={setHover}
                // rotation={[]}
            //   opacity={opacity}
            />
            <Texture
                //   key={key}
                {...props}
                texture={textures[1]}
                hoverValue={hoverValue}
                onHover={setHover}
                rotation={[0,degToRad(180),0,'XYZ']}
            //   opacity={opacity}
            />
        </>
    )
}

export default function ImageApp() {
    const dragDelta = useRef(0)

    const [props, set] = useSpring(() => ({
        pos: [0, 0, 0],
        scale: [1, 1, 1],
        rotation: [0, 0, 0],
        config: { mass: 10, tension: 1000, friction: 300, precision: 0.00001 }
    }))

    const [{ rotation }, setRotation] = useSpring(() => ({
        rotation: [0, 0, 0],
        config: { mass: 10, tension: 1000, friction: 300, precision: 0.00001 }
    }))

    const onClick = useCallback(
        e => {
            // filter clicks from dragging
            if (dragDelta.current < 100) {
                const [x, y, z] = rotation.getValue()

                setRotation({
                    rotation: [x, y + 180, z],
                    config: config.default
                })
            }
        },
        [rotation, setRotation]
    )

    const bind = useDrag(({ first, last, time, down, delta, velocity, direction, memo = rotation.getValue() }) => {
        if (first) {
            dragDelta.current = time
        }

        if (last) {
            dragDelta.current = time - dragDelta.current
        }

        const x = memo[0] + (delta[1] / window.innerWidth) * 180
        const y = memo[1] + (delta[0] / window.innerHeight) * 180
        const vxyz = [direction[1] * (velocity / 1), direction[0] * (velocity / 1), 0]

        setRotation({
            rotation: [x, y, 0],
            immediate: down,
            config: { velocity: vxyz, decay: true }
        })

        return memo
    })

    return (//5a5a5a
        <div
            //   className="main"
            style={{ width: '100%', height: '100%' }}
            {...bind()}
            onMouseMove={({ clientX, clientY }) => {
                const x = (clientX / window.innerWidth) * 2 - 1
                const y = -(clientY / window.innerHeight) * 2 + 1

                set({
                    pos: [x, 0, 0],
                    scale: [1 - y * 0.1, 1 - y * 0.1, 1]
                })
            }}>
            <Canvas pixelRatio={window.devicePixelRatio || 1} style={{ background: '#5a5a5a' }} camera={{ fov: 75, position: [0, 0, 7] }}>
                <Image url={image2} backUrl={image} {...props} onClick={onClick} rotation={rotation} />
                <OrbitControls enablePan={false} enableZoom={true} maxPolarAngle={Math.PI / 2} minPolarAngle={Math.PI / 2} />
            </Canvas>

        </div>
    )
}


const HoverImageShader = {
    vertexShader: `
      varying vec2 vUv; 
  
      void main() {
        vUv = uv;
  
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,
    fragmentShader: `
      precision highp float; 
  
      uniform sampler2D texture;
      uniform float imageAspectRatio;
      uniform float aspectRatio;
      uniform float opacity;
      uniform float hover;
      varying vec2 vUv;
  
      float exponentialInOut(float t) {
        return t == 0.0 || t == 1.0 
          ? t 
          : t < 0.5
            ? +0.5 * pow(2.0, (20.0 * t) - 10.0)
            : -0.5 * pow(2.0, 10.0 - (t * 20.0)) + 1.0;
      } 
  
      void main() {
        vec2 uv = vUv;
  
        // fix aspectRatio
        float u = imageAspectRatio/aspectRatio;
        if(imageAspectRatio > aspectRatio) {
          u = 1. / u;
        }
  
        uv.y *= u;
        uv.y -= (u)/2.-.5;
  
        // hover effect
        float zoomLevel = .2;
        float hoverLevel = exponentialInOut(min(1., (distance(vec2(.5), uv) * hover) + hover));
        uv *= 1. - zoomLevel * hoverLevel;
        uv += zoomLevel / 2. * hoverLevel;
        uv = clamp(uv, 0., 1.);
        vec4 color = texture2D(texture, uv);
        if(hoverLevel > 0.) {
          hoverLevel = 1.-abs(hoverLevel-.5)*2.;
          //Pixel displace
          uv.y += color.r * hoverLevel * .05;
          color = texture2D(texture, uv);
          // RGBshift
          color.r = texture2D(texture, uv+(hoverLevel)*0.01).r;
          color.g = texture2D(texture, uv-(hoverLevel)*0.01).g;
        }
  
        gl_FragColor = mix(vec4(1.,1.,1.,opacity), color, opacity);
      }
    `,
    uniforms: {
        texture: {
            type: 't',
            value: ''
        },
        imageAspectRatio: {
            type: 'f',
            value: 1.0
        },
        aspectRatio: {
            type: 'f',
            value: 1.0
        },
        opacity: {
            type: 'f',
            value: 1.0
        },
        hover: {
            type: 'f',
            value: 0.0
        }
    }
}